import { Stack, Typography, Grid, FormControl, TextField } from '@mui/material';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { RootState, useSelector } from '../../redux/store';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../utils/axios';
import refactorDevices from 'components/device/Components/refactorDevices';
import { Device, percentDeviceTypes, RefactoredDevice } from '../../@types/model/device';
import { DeviceType } from '../../@types/model/user';
import Page from 'components/Page';
import LoadingSpinnerTransparent from 'components/LoadingSpinnerTransparent';
import { useTheme, styled } from '@mui/material/styles';
import DeviceGroupPicker from 'components/DeviceGroupPicker';
import DeliveryConfigurationPicker from 'components/DeliveryConfigurationPicker';
import { DeliveryConfiguration } from '../../@types/model/deliveryConfiguration';
import { v4 as uuidv4 } from 'uuid';

import '../../assets/css/newDeliver.scss';
import PercentDeliver from './components/pieces/PercentDeliver';
import RowDeliver from './components/pieces/RowDeliver';
import { DeliverFilter } from '../../@types/model/deliver';
import DeviceTypePicker from 'components/DeviceTypePicker';
import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import DayjsUtils from '@date-io/dayjs';
import dayjs, { Dayjs } from 'dayjs';
import { DeviceTag } from '../../@types/model/user';
import { MIconButton } from 'components/@material-extend';
import { useSnackbar } from 'notistack';
import { generatePath, useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'routes/paths';
import { getProductSchedule, productScheduleState } from 'recoil/productScheduleState';
import { ProductSchedule } from '../../@types/model/productSchedule';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import NewDeliverSilosRow from './components/NewDeliverSilosRow';
import { DeliveryRequest, DeliveryRequestItem } from '../../@types/model/deliveryRequest';
import addSlot from './components/functions/addSlot';
import getIndexRemoveSlot from './components/functions/removeSlot';
import DeliveryBarTruckSilos from './components/DeliveryBarTruckSilos';
import { deliveryConfigurationState } from 'recoil/deliveryConfigurationState';
import { mergeById, uniqueArray2 } from 'recoil/utils';

const filterDevices = (devices: Device[]) =>
  devices.filter((d: Device) => percentDeviceTypes.includes(d.attributes.device_type));

export const getDevices = async (
  okCallback: (
    deviceGroups: Device[],
    totalCount: number,
    deviceTags: DeviceTag[],
    deliveryConfigurations: DeliveryConfiguration[],
    deliveryRequests: DeliveryRequest[]
  ) => void
): Promise<void> => {
  await axios
    .get('/api/v2/device', {
      params: {
        offset: 0,
        size: 100,
        order_by: 'name',
        direction: 'asc'
      }
    })
    .then(async ({ data }: any) => {
      let deviceTags: DeviceTag[] = data.included
        .filter((include: any) => include.type === 'App\\Domain\\Model\\DeviceTag\\DeviceTag')
        .map((include: any) => include as DeviceTag);
      let deliveryConfigurations: DeliveryConfiguration[] = data.included
        .filter(
          (include: any) => include.type === 'App\\Order\\Domain\\Model\\DeliveryConfiguration'
        )
        .map((include: any) => {
          return { ...include?.attributes, guid: include?.guid } as DeliveryConfiguration;
        });
      let devices = data.data.map((item: any) => {
        return item as Device;
      });
      let devices_original_guids = uniqueArray2(
        devices.map((device: Device) => {
          if (device.attributes.is_ref_of && device.attributes.is_ref_of !== '') {
            if (device.attributes.is_ref_of.split(':').length === 3) {
              return device.attributes.is_ref_of.split(':')[2];
            }
            return device.guid;
          } else {
            return device.guid;
          }
        })
      );
      console.log('devices_original_guids', devices_original_guids);
      // Vamos a obtener todos los tags de los dispositivos
      let deviceTagsGuids: string[] = [];
      devices.forEach(async (device: Device) => {
        if (device.attributes.tags && device.attributes.tags.length > 0) {
          deviceTagsGuids = deviceTagsGuids.concat(device.attributes.tags);
        }
      });
      console.log('deviceTagsGuids', deviceTagsGuids);

      // Obtenemos los tags de los dispositivos por si las moscas.
      await axios
        .get('/api/v2/device-tag/get-multiple', {
          params: {
            tags: uniqueArray2(deviceTagsGuids)
          }
        })
        .then(async ({ data }: any) => {
          console.log('data result device-tag get-multiple', data.data);
          data.data.forEach((dt: DeviceTag) => {
            let index = deviceTags.findIndex((d: DeviceTag) => d.guid === dt.guid);
            if (index === -1) {
              deviceTags.push(dt);
            } else {
              // deviceTags[index] = dt;
            }
          });
        });

      console.log('deviceTags merged!', deviceTags);
      let workspaces = uniqueArray2(
        devices.map((device: Device) => {
          return device.attributes.workspace;
        })
      );
      await axios
        .get('/api/v2/delivery-request/active-by-device', {
          params: {
            devices: devices_original_guids,
            workspaces: workspaces
          }
        })
        .then(({ data }: any) => {
          okCallback(
            devices,
            data.meta.total_count,
            deviceTags,
            deliveryConfigurations,
            data.data.map((dat: any) => {
              return {
                guid: dat.guid,
                ...dat.attributes,
                items: dat.attributes.items.map((i: any) => {
                  return {
                    guid: i.guid,
                    ...i.attributes
                  };
                })
              };
            })
          );
        });
    });
};

const ButtonDeliver = styled(LoadingButton)(({ theme }) => ({
  marginLeft: 20,
  width: '45%',
  display: 'inline-block',
  [theme.breakpoints.up('sm')]: {
    width: 150,
    display: 'inherit',
    marginTop: 10
  },
  background: '#FF6200',
  color: 'white',
  maxWidth: 200
}));

const NewDeliverSilos = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [devices, setDevices] = useState<Device[]>([]);
  const [deviceTags, setDeviceTags] = useState<DeviceTag[]>([]);
  const [totalTruck, setTotalTruck] = useState<number>(0);
  const [refactoredDevices, setRefactoredDevices] = useState<RefactoredDevice[]>([]);
  const [filteredRefactoredDevices, setFilteredRefactoredDevices] = useState<RefactoredDevice[]>(
    []
  );
  const [deliveryRequestItems, setDeliveryRequestItems] = useState<DeliveryRequestItem[]>([]);
  const [deliveryConfigurationSelected, setDeliveryConfigurationSelected] =
    useState<DeliveryConfiguration | null>(null);
  const [unit, setUnit] = useState<string>('Kg');
  const [min, setMin] = useState<number>(1);
  const [max, setMax] = useState<number>(6);
  const [, setSlots] = useState<number>(6);
  const [slot_amount, setSlotAmount] = useState<number>(4000);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const { deviceTypes } = useSelector((state: RootState) => state.user);
  // const { deviceTags } = useSelector((state: RootState) => state.user);

  const [deviceTypeAvailable, setDeviceTypeAvailable] = useState<string[]>([]);
  const [deliveryConfigurationAvailable, setDeliveryConfigurationAvailable] = useState<string[]>(
    []
  );
  const deliveryConfigurations: DeliveryConfiguration[] = useRecoilValue(
    deliveryConfigurationState
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const theme = useTheme();
  const { t } = useTranslation(['translation', 'custom']);
  const unique = (arr: any[]) => {
    return arr.filter(function (el, index, arr) {
      return index === arr.indexOf(el);
    });
  };

  const productSchedules: ProductSchedule[] = useRecoilValue(productScheduleState);
  const setProductSchedule = useSetRecoilState(productScheduleState);
  const setDeliveryConfigurations = useSetRecoilState(deliveryConfigurationState);

  useEffect(() => {
    getProductSchedule().then((productSchedules: ProductSchedule[]) => {
      setProductSchedule(productSchedules);
    });
  }, []);

  const solicitarSuministro = async () => {
    setLoading(true);
    let delivery_date = tableFilter?.receivedDate?.unix();
    delivery_date = (delivery_date ?? 0) * 1000;
    const data = {
      guid: uuidv4(),
      delivery_configuration: tableFilter.deliveryConfiguration,
      tags: [tableFilter.deviceGroup],
      delivery_date: delivery_date,
      items: deliveryRequestItems.map((dri: DeliveryRequestItem) => {
        return {
          ...dri,
          product_type_guid: dri.productType,
          product_schedule_item_guid: dri.productScheduleItem
        };
      })
    };
    await axios.post('/api/v2/delivery-request', data).then(({ data }: any) => {
      enqueueSnackbar(t('solicitud_de_suministro'), {
        variant: 'success',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      setLoading(false);
      navigate(generatePath(PATH_DASHBOARD.end_user.delivery_request.list));
    });
  };

  const [tableFilter, setTableFilter] = useState({
    deviceGroup: undefined,
    deliveryConfiguration: undefined,
    deviceTypePreset: '',
    receivedDate: dayjs().add(2, 'day')
  } as DeliverFilter);

  useEffect(() => {
    console.log('deliveryConfigurations', deliveryConfigurations);
    let dt: DeviceType[] = deviceTypes.filter((dt: DeviceType) => {
      if (dt.guid === tableFilter.deviceTypePreset) return true;
      return false;
    });
    if (dt.length > 0) {
      setDeliveryConfigurationAvailable(
        deliveryConfigurations
          .filter((dco: DeliveryConfiguration) => {
            if (dco.configuration.device_type === dt[0].guid) return true;
            return false;
          })
          .map((dco: DeliveryConfiguration) => {
            return dco.guid;
          })
      );
    }
  }, [tableFilter]);

  useEffect(() => {
    const fetchData = async () => {
      setLoadingDevices(true);
      await getDevices(
        (
          data: Device[],
          count: number,
          deviceTags: DeviceTag[],
          deliveryConfigurationsReceived: DeliveryConfiguration[],
          deliveryRequests: DeliveryRequest[]
        ) => {
          data.map((device: Device) => {
            // device.attributes.delivery_configurations = ['1', '2', '5', '6'];
            return device;
          });
          const filteredDevices = filterDevices(data);
          setDevices(filteredDevices);

          const refactoredDevices: RefactoredDevice[] = refactorDevices(
            filteredDevices,
            deliveryRequests
          );

          setRefactoredDevices(refactoredDevices);
          setFilteredRefactoredDevices(refactoredDevices);

          //We have to merge the deliveryConfigurations
          setDeliveryConfigurations(
            mergeById(deliveryConfigurations, deliveryConfigurationsReceived)
          );

          setDeviceTags(deviceTags);

          setDeviceTypeAvailable(
            unique(
              refactoredDevices.map((rd: RefactoredDevice) => {
                return rd.attributes.device_type_preset;
              })
            )
          );

          if (deviceTags.length === 1) {
            if (deviceTags[0].attributes.delivery_configurations.length === 1) {
              setTableFilter({
                ...tableFilter,
                deviceGroup: deviceTags[0].guid,
                deliveryConfiguration: deviceTags[0].attributes.delivery_configurations[0]
              });
            }
          }
        }
      );
      setLoadingDevices(false);
    };
    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    let totalTruck = 0;
    filteredRefactoredDevices.forEach((filteredRefactoredDevice) => {
      totalTruck += filteredRefactoredDevice.slotsNumber;
    });
    setTotalTruck(totalTruck);
  }, [filteredRefactoredDevices]);

  useEffect(() => {
    let newDevices = refactoredDevices.filter((device) => {
      let checkDeviceTypePreset = true;
      if (tableFilter.deviceTypePreset) {
        checkDeviceTypePreset = false;
        if (device.attributes.device_type_preset === tableFilter.deviceTypePreset)
          checkDeviceTypePreset = true;
      }
      let checkDeviceGroup = true;
      if (tableFilter.deviceGroup) {
        checkDeviceGroup = false;
        if (device.attributes.tags.includes(tableFilter.deviceGroup)) checkDeviceGroup = true;
      }
      let checkDeliveryConfiguration = false;
      if (checkDeviceTypePreset && checkDeviceGroup) checkDeliveryConfiguration = true;
      if (tableFilter.deliveryConfiguration) {
        if (
          device.attributes.delivery_configurations &&
          device.attributes.delivery_configurations.length > 0
        ) {
          if (
            device.attributes.delivery_configurations.includes(tableFilter.deliveryConfiguration)
          ) {
            checkDeliveryConfiguration = true;
          } else {
            checkDeliveryConfiguration = false;
          }
        } else {
          let deviceTagsFiltered = deviceTags.filter((dt) => {
            if (dt.guid === tableFilter.deviceGroup) return true;
            return false;
          });
          if (deviceTagsFiltered.length > 0) {
            if (
              deviceTagsFiltered[0].attributes.delivery_configurations &&
              deviceTagsFiltered[0].attributes.delivery_configurations.length > 0
            ) {
              if (
                deviceTagsFiltered[0].attributes.delivery_configurations.includes(
                  tableFilter.deliveryConfiguration
                )
              ) {
                checkDeliveryConfiguration = true;
              } else {
                checkDeliveryConfiguration = false;
              }
            }
          }
        }
      }
      return checkDeviceGroup && checkDeviceTypePreset && checkDeliveryConfiguration;
    });

    newDevices = newDevices.map((rd: RefactoredDevice) => {
      if (rd.productSchedule) return rd;
      let guidCorrected = rd.guid;
      if (rd.attributes.is_ref_of) {
        if (rd.attributes.is_ref_of.split(':').length === 3) {
          guidCorrected = rd.attributes.is_ref_of.split(':')[2];
        }
      }
      const schedules = productSchedules.filter((ps: ProductSchedule) => {
        if (ps.devices.includes(guidCorrected)) return true;
        return false;
      });
      if (schedules.length > 0) {
        return {
          ...rd,
          productSchedule: schedules[0]
        };
      }
      return rd;
    });

    setFilteredRefactoredDevices(newDevices);
    if (tableFilter.deliveryConfiguration) {
      deliveryConfigurations.forEach((dc: DeliveryConfiguration) => {
        if (dc.guid === tableFilter.deliveryConfiguration) {
          setDeliveryConfigurationSelected(dc);
          setMin(dc.configuration.min);
          setMax(dc.configuration.max);
          setSlots(dc.configuration.slots);
          setSlotAmount(dc.configuration.slot_amount);
          setUnit(dc.units);
        }
      });
    }
  }, [tableFilter, devices, refactoredDevices, productSchedules]);

  const setDeliveryConfiguration = (deviceTypePreset: string, deviceGroup: string) => {
    const deviceTagsSelected = deviceTags.filter((dg: DeviceTag) => {
      if (dg.guid === deviceGroup) return true;
      return false;
    });
    if (deviceTagsSelected.length > 0) {
      const deviceTagSelected = deviceTagsSelected[0];
      let deliveryConfigurationSelected =
        deviceTagSelected.attributes.delivery_configurations.filter((dc: string) => {
          return deliveryConfigurationAvailable.filter((dca: string) => {
            if (dca === dc) return true;
            return false;
          }).length;
        });
      deliveryConfigurationSelected = deliveryConfigurations
        .filter((dc) => {
          if (deliveryConfigurationSelected.includes(dc.guid)) {
            if (dc.device_types.includes(deviceTypePreset)) return true;
          }
          return false;
        })
        .map((dc) => {
          return dc.guid;
        });
      if (deliveryConfigurationSelected.length > 0) {
        setTableFilter({
          ...tableFilter,
          deviceTypePreset: deviceTypePreset,
          deviceGroup: deviceTagSelected.guid,
          deliveryConfiguration: deliveryConfigurationSelected[0]
        });
      } else {
        setTableFilter({
          ...tableFilter,
          deviceTypePreset: deviceTypePreset,
          deviceGroup: deviceGroup,
          deliveryConfiguration: ''
        });
      }
    }
  };

  return (
    <Page title={'Giraf'} style={{ padding: 10 }}>
      <Typography id="modal-modal-title" variant="h6" component="h2" style={{ marginBottom: 20 }}>
        {t('new_delivery')}
      </Typography>
      <Typography variant="body1" component="div" style={{ marginBottom: 20 }}>
        {t('para_realizar_un_pedido', { ns: 'custom' })}
      </Typography>
      <Grid container spacing={2} direction="row" sx={{ marginBottom: '20px' }}>
        <Grid item xs={12} sm={6} md={4}>
          <DeviceTypePicker
            deviceTypePreset={tableFilter.deviceTypePreset}
            changeHandler={(deviceTypePreset: string) => {
              setTableFilter({
                ...tableFilter,
                deviceTypePreset: deviceTypePreset
              });
              setDeliveryConfiguration(deviceTypePreset, tableFilter.deviceGroup ?? '');
            }}
            deviceTypeAvailable={deviceTypeAvailable}
          ></DeviceTypePicker>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DeviceGroupPicker
            deviceGroupGuid={tableFilter.deviceGroup}
            changeHandler={(deviceGroupGuid) => {
              if (deviceGroupGuid) {
                setTableFilter({ ...tableFilter, deviceGroup: deviceGroupGuid });
                setDeliveryConfiguration(tableFilter.deviceTypePreset, deviceGroupGuid);
              } else {
                setTableFilter({ ...tableFilter, deviceGroup: undefined });
              }
            }}
            deviceTags={deviceTags}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DeliveryConfigurationPicker
            deliveryConfigurationGuid={tableFilter.deliveryConfiguration}
            changeHandler={(deliveryConfigurationGuid) => {
              if (deliveryConfigurationGuid) {
                setTableFilter({
                  ...tableFilter,
                  deliveryConfiguration: deliveryConfigurationGuid
                });
              } else {
                setTableFilter({ ...tableFilter, deliveryConfiguration: undefined });
              }
            }}
            deliveryConfigurationAvailable={deliveryConfigurationAvailable}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl sx={{ mt: 2 }} fullWidth>
            <LocalizationProvider
              dateAdapter={DayjsUtils}
              locale={navigator.language.split('-')[0]}
            >
              <DatePicker
                label={t('received_date')}
                value={tableFilter.receivedDate}
                onChange={(value: Dayjs | null) =>
                  setTableFilter({
                    ...tableFilter,
                    receivedDate: value
                  })
                }
                renderInput={(params) => <TextField {...params} />}
                maxDate={dayjs().add(10, 'day')}
                minDate={dayjs().add(2, 'day')}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
      </Grid>
      <Stack style={{ position: 'relative' }}>
        {loadingDevices && (
          <div className="loadingDeviceSpinner">
            <LoadingSpinnerTransparent />
          </div>
        )}
        <Fragment>
          {filteredRefactoredDevices.map((rd: RefactoredDevice) => {
            return (
              <NewDeliverSilosRow
                refactoredDevices={refactoredDevices}
                key={rd.guid}
                rd={rd}
                slot_amount={slot_amount}
                unit={unit}
                tableFilter={tableFilter}
                totalTruck={totalTruck}
                max={max}
                productSchedules={productSchedules}
                deliveryRequestItems={deliveryRequestItems}
                deliveryConfiguration={deliveryConfigurationSelected}
                addSlot={(guid: string) => {
                  let newDeliveryRequestItem = addSlot(
                    rd,
                    deliveryRequestItems,
                    productSchedules,
                    deliveryConfigurationSelected
                  );
                  if (newDeliveryRequestItem)
                    setDeliveryRequestItems([...deliveryRequestItems, newDeliveryRequestItem]);
                }}
                removeSlot={(guid: string) => {
                  let indexToDelete = getIndexRemoveSlot(rd, deliveryRequestItems);
                  setDeliveryRequestItems(
                    deliveryRequestItems.filter(
                      (dri: DeliveryRequestItem, index: number) => index !== indexToDelete
                    )
                  );
                }}
              />
            );
          })}
          <RowDeliver className="newDeliverSilorRow truck">
            <Typography
              variant="h6"
              component="h6"
              style={{
                marginBottom: 0,
                width: '100%',
                [theme.breakpoints.up('md')]: {
                  width: 'calc(100% - 400px)'
                },
                paddingLeft: '10px'
              }}
            >
              {t('TOTAL')}
            </Typography>
            <PercentDeliver className="percentDeliver">
              <DeliveryBarTruckSilos
                totalTruck={totalTruck}
                max={max}
                slot_amount={slot_amount}
                unit={unit}
                deliveryRequestItems={deliveryRequestItems}
                deliveryConfiguration={deliveryConfigurationSelected}
              />

              <ButtonDeliver
                disabled={
                  deliveryRequestItems.length === 0 || deliveryRequestItems.length < min
                    ? true
                    : false
                }
                loading={loading}
                variant={'contained'}
                onClick={() => solicitarSuministro()}
              >
                {t('request_delivery')}
              </ButtonDeliver>
            </PercentDeliver>
          </RowDeliver>
        </Fragment>
      </Stack>
    </Page>
  );
};

export default NewDeliverSilos;
